export default function sanitizeEditorHtml(html) {
 const template=document.createElement('template'); template.innerHTML=String(html||'');
 template.content.querySelectorAll('script,iframe,object,embed,form,input,textarea,select,meta,link,base,style,foreignObject,animate,set').forEach(el=>el.remove());
 for(const el of template.content.querySelectorAll('*')) for(const attr of [...el.attributes]) {
  const name=attr.name.toLowerCase(), value=Array.from(attr.value).filter(c => c.charCodeAt(0) > 32).join('');
  if(name.startsWith('on')||['srcdoc','formaction','xlink:href'].includes(name)||(['href','src','data-link','data-btn-url'].includes(name)&&/^(javascript|vbscript|data|file):/i.test(value))||(name==='style'&&/expression\s*\(|javascript:|behavior\s*:/i.test(value)))el.removeAttribute(attr.name);
 }
 return template.innerHTML;
}
